import { render, staticRenderFns } from "./customerOrders.vue?vue&type=template&id=c9bed926&"
import script from "./customerOrders.vue?vue&type=script&lang=js&"
export * from "./customerOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports